import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Zap, Newspaper, FileText } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DailyPulse = () => {
  const [d, setD] = useState(null);
  useEffect(() => {
    fetch(`${API}/daily-highlight`).then((r) => r.json()).then(setD).catch(() => {});
  }, []);
  if (!d) return null;
  return (
    <section className="border-y border-white/5 bg-gf-surface/60" data-testid="daily-pulse">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-3.5 flex flex-wrap items-center gap-x-8 gap-y-2">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gf-primary shrink-0 flex items-center gap-2">
          <Zap className="w-3.5 h-3.5" /> Today · {d.date}
        </p>
        <p className="font-body text-xs text-gf-text/90 flex-1 min-w-[240px]" data-testid="daily-insight">{d.insight}
          {d.insight_source && (d.insight_source.url?.startsWith("/") ? (
            <Link to={d.insight_source.url} data-testid="daily-insight-source"
              className="ml-2 font-mono text-[8px] uppercase tracking-wide text-gf-muted/70 underline decoration-gf-primary/40 underline-offset-2 hover:text-gf-primary transition-colors">Source: {d.insight_source.label}</Link>
          ) : (
            <a href={d.insight_source.url} target="_blank" rel="noopener noreferrer" data-testid="daily-insight-source"
              className="ml-2 font-mono text-[8px] uppercase tracking-wide text-gf-muted/70 underline decoration-gf-primary/40 underline-offset-2 hover:text-gf-primary transition-colors">Source: {d.insight_source.label}</a>
          ))}
        </p>
        <div className="flex flex-wrap items-center gap-x-6 gap-y-1.5">
          {d.blog && (
            <Link to={`/insights/${d.blog.slug}`} className="inline-flex items-center gap-1.5 font-body text-xs text-gf-muted hover:text-gf-primary transition-colors" data-testid="daily-blog-link">
              <Newspaper className="w-3.5 h-3.5 text-gf-primary" /> <span className="max-w-[260px] truncate">{d.blog.title}</span>
            </Link>
          )}
          <Link to="/tenders" className="inline-flex items-center gap-1.5 font-body text-xs text-gf-muted hover:text-gf-primary transition-colors" data-testid="daily-tenders-link">
            <FileText className="w-3.5 h-3.5 text-gf-primary" /> {d.tenders_live} live tenders
          </Link>
        </div>
      </div>
    </section>
  );
};
